import CMSPageDataServices from '../../cms/services/cms-pages.service';
import { AUTHOR_MAX_LIMIT } from '../constants';
import { IAUTHOR } from '../types';

export const extractParagraph = (
  content: string,
  paraLength: number
): string => {
  if (!content) return '';

  const strippedContent = content.replace(/(<([^>]+)>)/gi, ''); // remove HTML tags
  const sentences = strippedContent.split('. '); // split content into sentences
  const paragraph = sentences.slice(0, paraLength).join('. '); // join first 3 sentences into a paragraph

  return paragraph + '.';
};

export const getActiveAuthors = async (
  domain: number,
  page: number,
  limit = AUTHOR_MAX_LIMIT
) => {
  const res = await CMSPageDataServices.getAllAuthors(domain, page, limit);
  const authorData = await res.data;
  const activeAuthors = authorData.results.filter(
    (author: IAUTHOR) => author.status === true
  );
  const paginatedActiveAuthors = {
    ...authorData,
    results: activeAuthors,
  };
  return paginatedActiveAuthors;
};

export const getStaticPropsAuthorData = async (
  DOMAIN_CODE: number,
  DEFAULT_PAGE: number
) => {
  const data = await getActiveAuthors(DOMAIN_CODE, DEFAULT_PAGE);
  return {
    props: {
      data: data,
    },
  };
};
